/**
 * How a total divides between what is earned and what is estimated: the
 * fraction of it that is earned. A part that is a loss has no share, so the
 * other part is the whole; undefined where neither part is a gain and there
 * is nothing to divide.
 */
export function earnedShare(
  earned: number,
  estimated: number,
): number | undefined {
  const earnedGain = Math.max(0, earned);
  const whole = earnedGain + Math.max(0, estimated);
  return whole > 0 ? earnedGain / whole : undefined;
}
